import {
  ContentAuthor,
  Maybe,
  SocialMediaAccount,
  SocialMediaType,
} from "@/graphql/gql/graphql";

type SocialMediaAccounts = Maybe<Maybe<SocialMediaAccount>[]>;

export const getTwitterAccount = (socialMedia: SocialMediaAccounts) =>
  socialMedia?.find((account) => account?.type === SocialMediaType.Twitter);

export const getFacebookAccount = (socialMedia: SocialMediaAccounts) =>
  socialMedia?.find((account) => account?.type === SocialMediaType.Facebook);

// an "updated by" credit is redundant when it names the original author
export const getDistinctUpdatedBy = (
  author: Maybe<Pick<ContentAuthor, "id">> | undefined,
  updatedBy: Maybe<ContentAuthor> | undefined
) => (updatedBy && updatedBy.id !== author?.id ? updatedBy : undefined);
